import styled from "@emotion/styled";
import { PageVariant } from "./Page";

export const PageRoot = styled.div<{ variant: PageVariant }>(({ theme, variant }) => ({
	width: "100%",
	minWidth: 0,
	minHeight: "100%",
	background:
		variant === "orders"
			? "linear-gradient(180deg, #006594 0, #4d97b7 160px, #f7f7f7 360px)"
			: theme.project.colors.backgroundColors.main
}));
